// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// function ResetPassword() {
//   const [newPassword, setNewPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const location = useLocation();
//   const navigate = useNavigate();
//   const query = new URLSearchParams(location.search);
//   const email = query.get('email');
//   const timestamp = query.get('t');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post('http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/check_login.php', {
//         action: 'reset_password',
//         api_key: '1',
//         email: email,
//         new_password: newPassword,
//         timestamp: timestamp
//       });
//       if (response.data.status === 'true') {
//         setMessage('Password reset successfully!');
//         setTimeout(() => navigate('/login'), 2000);
//       } else {
//         setMessage(response.data.response);
//       }
//     } catch (error) {
//       setMessage('Error resetting password.');
//     }
//   };

//   return (
//     <div>
//       <h2>Reset Password</h2>
//       {message && <p>{message}</p>}
//       {!message && (
//         <form onSubmit={handleSubmit}>
//           <label>New Password: <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required /></label>
//           <button type="submit">Reset Password</button>
//         </form>
//       )}
//     </div>
//   );
// }

// export default ResetPassword;


////&********************** done**********************////

// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// export default function ResetPassword() {
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');
//   const location = useLocation();
//   const navigate = useNavigate();
//   const query = new URLSearchParams(location.search);
//   const email = query.get('email');
//   const timestamp = query.get('t');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Validate passwords match
//     if (newPassword !== confirmPassword) {
//       setMessage('Passwords do not match');
//       setMessageType('error');
//       return;
//     }
    
//     try {
//       const response = await axios.post('http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/check_login.php', {
//         action: 'reset_password',
//         api_key: '1',
//         email: email,
//         new_password: newPassword,
//         timestamp: timestamp
//       });
      
//       if (response.data.status === 'true') {
//         setMessage('Password reset successfully!');
//         setMessageType('success');
//         setTimeout(() => navigate('/login'), 2000);
//       } else {
//         setMessage(response.data.response);
//         setMessageType('error');
//       }
//     } catch (error) {
//       setMessage('Error resetting password. Please try again.');
//       setMessageType('error');
//     }
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-blue-50">
//       <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-lg">
//         <div className="text-center">
//           <h2 className="text-3xl font-bold text-blue-700">Reset Password</h2>
//           <p className="mt-2 text-gray-600">Enter your new password below</p>
//         </div>
        
//         {message && (
//           <div className={`p-4 rounded-md ${messageType === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//             {message}
//           </div>
//         )}
        
//         {!messageType || messageType === 'error' ? (
//           <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
//             <div>
//               <label htmlFor="new-password" className="block text-sm font-medium text-gray-700">
//                 New Password
//               </label>
//               <div className="mt-1">
//                 <input
//                   id="new-password"
//                   name="newPassword"
//                   type="password"
//                   required
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter new password"
//                 />
//               </div>
//             </div>
            
//             <div>
//               <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700">
//                 Confirm Password
//               </label>
//               <div className="mt-1">
//                 <input
//                   id="confirm-password"
//                   name="confirmPassword"
//                   type="password"
//                   required
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Confirm new password"
//                 />
//               </div>
//             </div>
            
//             <div>
//               <button
//                 type="submit"
//                 className="w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-300"
//               >
//                 Reset Password
//               </button>
//             </div>
//           </form>
//         ) : null}
        
//         <div className="text-center mt-4">
//           <a href="/login" className="text-sm text-blue-600 hover:text-blue-800">
//             Back to Login
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }


/************************* */


import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Eye, EyeOff } from 'lucide-react'; // make sure you have lucide-react installed or use other icons
import { BaseUrl } from "../App";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const email = query.get('email');
  const timestamp = query.get('t');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword.length < 8) {
      setMessage('Password must be at least 8 characters');
      setMessageType('error');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match');
      setMessageType('error');
      return;
    }

    try {
      const response = await axios.post(
        // 'http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/check_login.php',
        `${BaseUrl}/backend/api/check_login.php`,
        {
          action: 'reset_password',
          api_key: '1',
          email: email,
          new_password: newPassword,
          timestamp: timestamp,
        }
      );

      if (response.data.status === 'true') {
        setMessage('Password reset successfully!');
        setMessageType('success');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage(response.data.response);
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Error resetting password. Please try again.');
      setMessageType('error');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-blue-50">
      <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-blue-700">Reset Password</h2>
          <p className="mt-2 text-gray-600">Enter your new password below</p>
        </div>

        {message && (
          <div
            className={`p-4 rounded-md ${
              messageType === 'success'
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {message}
          </div>
        )}

        {!messageType || messageType === 'error' ? (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            {/* New Password */}
            <div className="relative">
              <label htmlFor="new-password" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                id="new-password"
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter new password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-9 right-3 text-gray-500"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
              {newPassword && newPassword.length < 8 && (
                <p className="text-sm text-red-500 mt-1">Password must be at least 8 characters</p>
              )}
            </div>

            {/* Confirm Password */}
            <div className="relative">
              <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <input
                id="confirm-password"
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Confirm new password"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute top-9 right-3 text-gray-500"
              >
                {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {/* Submit Button */}
            <div>
              <button
                type="submit"
                className="w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-300"
              >
                Reset Password
              </button>
            </div>
          </form>
        ) : null}

        <div className="text-center mt-4">
          <a href="/login" className="text-sm text-blue-600 hover:text-blue-800">
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}
